import React, { PureComponent } from 'react';
import type { WrappedComponentProps } from 'react-intl-next';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl-next';

import { EmptyStateWrapper } from './EmptyStateWrapper';
import searchErrorImage from './SearchError.svg';

const i18n = defineMessages({
	header: {
		id: 'template-list.empty-search-results.headline',
		defaultMessage: 'We couldn’t find any templates',
		description:
			'This is the headline that shows when the user’s search query does not match any of the available templates',
	},
	description: {
		id: 'template-list.empty-search-results.description',
		defaultMessage:
			'No templates matched your search.{lineBreak} Try again with different keywords.',
		description:
			'This is the description that shows when the user’s search query does not match any of the available templates',
	},
});

const lineBreak = { lineBreak: <br /> };
export const NoSearchResultsTemplateList = injectIntl(
	class NoSearchResultsTemplateList extends PureComponent<WrappedComponentProps> {
		render() {
			return (
				<EmptyStateWrapper
					header={this.props.intl.formatMessage(i18n.header)}
					description={<FormattedMessage {...i18n.description} values={lineBreak} />}
					imageUrl={searchErrorImage}
					imageHeight={109}
				/>
			);
		}
	},
);
